// extracted by mini-css-extract-plugin
export default {"container":"AppTemplateList_container_S4K1B"};